var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta!='download')?_c('Head'):_vm._e(),(_vm.$route.meta!='download')?_c('div',{staticClass:"layout"},[(_vm.isAlive)?_c('router-view'):_vm._e()],1):_vm._e(),(_vm.$route.meta=='download')?_c('router-view'):_vm._e(),(_vm.$route.meta!='download')?_c('Foot'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }